import {TextButton} from '../../index'
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore'

const PrevButton = ({className, onClick, disabled}) => {
    return (
        <TextButton className={className} clickHandler={onClick} disabled={disabled} startIcon={<NavigateBeforeIcon/>}>Prev</TextButton>
    )
}

export default PrevButton
